export default __webpack_public_path__ + "static/media/EUNICE_POWER_ΗΛ.9ad3eaed.png";